/* eslint-disable max-len */
export function createProduktlyScript(clientToken: string): string {
  return `(function(w,d,f){
w.Produktly=w.Produktly||new Proxy(function(){},{get:function(_,n){return function(){w.ProduktlyQ=(w.ProduktlyQ||[]).concat([[n,Array.prototype.slice.call(arguments)]])}},apply:function(_,__,a){w.ProduktlyQ=(w.ProduktlyQ||[]).concat([["apply",a]])}});
w.Produktly.configure({waitForUser:true});
var a=d.getElementsByTagName("head")[0];
var s=d.createElement("script");
s.async=1;
s.src=f;
s.setAttribute("id","produktlyScript");
s.dataset.clientToken="${clientToken}";
a.appendChild(s);
})(window,document,"https://public.produktly.com/js/main.js");`;
}
